import React from 'react';
import Type from 'prop-types';
import { noop } from 'lodash';
import { Badge, Button, IconButton } from '@mui/material';
import styles from './AppBarAction.module.css';

const AppBarAction = (props) => {
  const { action, onActionSelected, iconSx } = props;

  const handleActionSelected = (event) => {
    const actionId = event.currentTarget.getAttribute('data-id');
    onActionSelected(actionId);
  };

  if (!action) {
    return null;
  }

  const IconAction = action.icon;

  if (!IconAction) {
    return (
      <Button
        key={action.title}
        color="primary"
        className={styles.edgeEnd}
        onClick={handleActionSelected}
        data-id={action.id}
        data-testid={action.dataTestId}
      >
        {action.title}
      </Button>
    );
  }

  return (
    <IconButton
      key={action.title}
      edge="end"
      color="inherit"
      sx={iconSx}
      aria-label={action.title}
      onClick={handleActionSelected}
      data-id={action.id}
      data-testid={action.dataTestId}
    >
      {action?.badge ? (
        <Badge {...action.badge}>
          <IconAction />
        </Badge>
      ) : (
        <IconAction />
      )}
    </IconButton>
  );
};

AppBarAction.propTypes = {
  action: Type.shape({
    id: Type.string.isRequired,
    title: Type.string.isRequired,
    show: Type.oneOf(['always', 'never']).isRequired,
    icon: Type.elementType,
    badge: Type.shape({
      badgeContent: Type.node,
    }),
    dataTestId: Type.string,
  }).isRequired,
  onActionSelected: Type.func,
  iconSx: Type.oneOfType([Type.object, Type.array, Type.func]),
};

AppBarAction.defaultProps = {
  onActionSelected: noop,
  iconSx: undefined,
};

export default AppBarAction;
